export const extractCategoriesUnlocalized = (
  hierarchicalCategories: {
    lvl10?: string[]
    lvl20?: string[]
    lvl30?: string[]
    lvl40?: string[]
  },
  categoryPageId2: string[]
): { category1: string; category2: string; category4: string } => {
  const defaultValues = { category1: '', category2: '', category4: '' }

  // Get the depth of the category from hierarchicalCategories key names
  const hierarchyLevel = Object.keys(hierarchicalCategories)
    .map(key => parseInt(key.replace('lvl', '').replace('0', ''))) // Extract level number
    .sort()

  if (!hierarchyLevel.length) return defaultValues

  const deepestLevel = Math.max(...hierarchyLevel)

  // Find the first category page id has the biggest hierarchy depth
  const targetCategoryPageId = categoryPageId2?.find(categoryId => {
    const splitCategory = categoryId.split('>')
    return splitCategory.length === deepestLevel
  })

  if (!targetCategoryPageId) {
    return defaultValues
  }

  const targetCategoriesSplit = targetCategoryPageId
    .split('>')
    .map(el => el.trim())

  // Armani-casa has 3 levels of categories
  if (deepestLevel === 3) {
    const [_, category1, category2] = targetCategoriesSplit

    return {
      category1,
      category2,
      category4: 'unisex', // Armani-casa is unisex
    }
  }

  const category4 =
    targetCategoriesSplit.find(category =>
      ['man', 'woman'].includes(category)
    ) ?? 'unisex'
  const category1 = targetCategoriesSplit.at(-2) ?? '' // Subcategory first level (macro category)
  const category2 = targetCategoriesSplit.at(-1) ?? '' // Subcategory second level (micro category)

  return {
    category1,
    category2,
    category4,
  }
}
